/* tslint:disable */
/* eslint-disable */
/**
 * Client dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectAnalyticsRequestDateRange } from './';
import {
    ProjectAnalyticsRequestDateRangeFromJSON,
    ProjectAnalyticsRequestDateRangeFromJSONTyped,
    ProjectAnalyticsRequestDateRangeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectAnalyticsRequest
 */
export interface ProjectAnalyticsRequest {
    /**
     * 
     * @type {string}
     * @memberof ProjectAnalyticsRequest
     */
    organizationId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectAnalyticsRequest
     */
    clientCompanyIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProjectAnalyticsRequest
     */
    currency?: string;
    /**
     * 
     * @type {ProjectAnalyticsRequestDateRange}
     * @memberof ProjectAnalyticsRequest
     */
    dateRange?: ProjectAnalyticsRequestDateRange;
}

/**
 * Check if a given object implements the ProjectAnalyticsRequest interface.
 */
export function instanceOfProjectAnalyticsRequest(value: object): value is ProjectAnalyticsRequest {
    if (!('clientCompanyIds' in value) || value['clientCompanyIds'] === undefined) return false;
    return true;
}

export function ProjectAnalyticsRequestFromJSON(json: any): ProjectAnalyticsRequest {
    return ProjectAnalyticsRequestFromJSONTyped(json, false);
}

export function ProjectAnalyticsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectAnalyticsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'clientCompanyIds': json['clientCompanyIds'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'dateRange': json['dateRange'] == null ? undefined : ProjectAnalyticsRequestDateRangeFromJSON(json['dateRange']),
    };
}

export function ProjectAnalyticsRequestToJSON(value?: ProjectAnalyticsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'organizationId': value['organizationId'],
        'clientCompanyIds': value['clientCompanyIds'],
        'currency': value['currency'],
        'dateRange': ProjectAnalyticsRequestDateRangeToJSON(value['dateRange']),
    };
}

